import React, { useContext } from 'react';
import {
	ClientSymbol,
	ClientText,
	Main,
	MedianSymbol,
	MedianText,
	Sub,
} from './ChartLegend.styles';
import { SettingsContext } from 'contexts/SettingsContext';

const ChartLegend = () => {
	const { companyName } = useContext(SettingsContext);
	return (
		<Main>
			<Sub>
				<ClientText title={companyName}>{companyName}</ClientText>
				<ClientSymbol />
			</Sub>
			<Sub>
				<MedianText>Median</MedianText>
				<MedianSymbol />
			</Sub>
		</Main>
	);
};

export default ChartLegend;
